import { render, staticRenderFns } from "./_base-select.vue?vue&type=template&id=d0cb5c14&scoped=true"
import script from "./_base-select.vue?vue&type=script&setup=true&lang=js"
export * from "./_base-select.vue?vue&type=script&setup=true&lang=js"
import style0 from "./_base-select.vue?vue&type=style&index=0&id=d0cb5c14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0cb5c14",
  null
  
)

export default component.exports